import { UpdateProfileViewModel } from '../account-models/user-models/update-profile-view-model.type';
import { MonitorKey } from '../monitor-models/monitor-key.type';

export class TagViewModel {
  Id: number = null;
  Title: string = null;
  Description: string = null;
  Color: string = '#4b0082';
  IsShared: boolean = false;
  IsSharedWithAllUsers: boolean = false;
  CreatorUserId: string;
  CreationDateTime?: Date;
  SharedUsers: UpdateProfileViewModel[] = [];
  MachinePhysicalAddress?: string = null;
  UsersWhoHaveAccessIds: string[] = []; // to delete
  AssignedMonitorKeys?: MonitorKey[] = [];
  IdAssignedPdfPlaylist: number;
  StartDelay: number;
  IsAndroid?: boolean;

  constructor(values: Partial<TagViewModel> = {}) {
    Object.assign(this, values);
  }
}
